import { combineReducers } from 'redux';
import roomReducer from './roomReducer';
import datesReducer from './datesReducer';
import roomFilterReducer from './roomFilterReducer';
const rootReducer = combineReducers({
  room: roomReducer,
  date: datesReducer,
  roomFilter: roomFilterReducer,
  // Add other reducers here in the future
});

export default rootReducer;
